import React from "react";
import { Outlet } from "react-router-dom";
// import GlobalLoader from "../../../shared/globalLoader";
import Sidebar from "./sidebar";

const RestaurantSalesLayout = () => {
  return (
    <>
    <div>
        <Sidebar />
        <Outlet />
    </div>
    </>
  );
};
export default RestaurantSalesLayout;
